export default "__VITE_ASSET__DmFHSqog__"